import { render, staticRenderFns } from "./ReviewModal.vue?vue&type=template&id=33f10866&scoped=true&"
import script from "./ReviewModal.vue?vue&type=script&lang=ts&"
export * from "./ReviewModal.vue?vue&type=script&lang=ts&"
import style0 from "./ReviewModal.vue?vue&type=style&index=0&id=33f10866&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f10866",
  null
  
)

export default component.exports